import { store } from "../Redux/Store";
import Type from "../Redux/Type";
import LinkAPI, { onGetRequestNoAuth, onPostRequest } from './MainController';
import { getListGiaDat } from './Search';

export const onLoadDanhMucBangGia = (loaidanhmuc, routeName) => {
    store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: true })
    let onSuccess = ({ statusCode, response }) => {

        if (statusCode === 200) {

            let dataReturn = response;
            store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: routeName, value: dataReturn })
        }
        store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: false })
    }
    onGetRequestNoAuth(LinkAPI.getDanhMucGiaDat(loaidanhmuc), onSuccess)
}

export const onLoadBangGia = (huyen, maxa, maloaidat, maduong, madoan) => {
    store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: true })
    store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'listPrice', value: [] })
    let onSuccess = ({ statusCode, response }) => {
        if (statusCode === 200) {
            let dataReturn = response;

            store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'listPrice', value: dataReturn })
            store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'showResult', value: true });
        }
        store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: false })
    }
    onGetRequestNoAuth(LinkAPI.getGiaDatTheoTieuChi(huyen, maxa, maloaidat, maduong, madoan), onSuccess)
}

export const onLoadDMDieuKien = (loaidm, maloai, maloai2, routeName) => {
    store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: true })
    let onSuccess = ({ statusCode, response }) => {
        if (statusCode === 200) {
            let dataReturn = response;
            store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: routeName, value: dataReturn })
        }
        store.dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'loadingSearch', value: false })
    }
    onGetRequestNoAuth(LinkAPI.getDanhMucGiaDatDieuKien(loaidm, maloai, maloai2), onSuccess)
}


const CoverArray = (arrayS, key, text) => {

    return arrayS.map((e, inx) => {
        if (!key)
            e.key = inx
        e.text = e['text']
    })
}